import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Spin } from 'antd';

const LoadingComp = function(props: any) {
  return (
    <div
      className={'alo7-modal-mask'}
      style={{
        zIndex: 1001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Spin size={'large'} {...props} />
    </div>
  );
};

export const Loading = React.memo(function(props: any) {
  const ele = document.createElement('div');
  ele.setAttribute('id', 'loading');
  useEffect(() => {
    document.body.appendChild(ele);
    return () => {
      document.body.removeChild(ele);
    };
  });
  return createPortal(<LoadingComp {...props} />, ele);
});
